module.exports = __webpack_public_path__ + "static/media/configuration.d611eff2.png";